<template>
  <v-data-table
    v-bind="tableProps"
    dense
    :headers="headers"
    :items="data"
    :loading="loading"
    @click:row="onRowClick"
  >
    <template v-slot:[`item.warehouse_id`]="{ item }">
      {{ item.warehouse_id[1] }}
    </template>
    <template v-slot:[`item.brand_id`]="{ item }">
      {{ item.brand_id[1] }}
    </template>
    <template v-slot:[`item.value`]="{ item }">
      {{ formatCurrency(item.value) }}
    </template>
  </v-data-table>
</template>

<script>
import { inject } from "vue-demi";
import { useDataTable } from "@/composables/api/data-table.js";
import { endOfMonth, startOfMonth } from "date-fns";
import { formatDate } from "@/utils/date";

export default {
  setup() {
    const { data, loading, headers, tableProps } = useDataTable("turnover");

    const showOnMap = inject("showOnMap");

    const onRowClick = item => {
      showOnMap({
        measure: "turnover",
        warehouse_id: item.warehouse_id[0],
        brand_id: item.brand_id[0],
        date_from: formatDate(startOfMonth(new Date())),
        date_to: formatDate(endOfMonth(new Date()))
      });
    };

    return {
      data,
      loading,
      headers,
      onRowClick,
      tableProps
    };
  }
};
</script>

<style></style>
